export const PROCESS_ORDERS_LIST_INITING = 'PROCESS_ORDERS_LIST_INITING'
export const PROCESS_ORDERS_LIST_REQUESTING = 'PROCESS_ORDERS_LIST_REQUESTING'
export const PROCESS_ORDERS_LIST_SUCCESS = 'PROCESS_ORDERS_LIST_SUCCESS'
export const PROCESS_ORDERS_LIST_ERROR = 'PROCESS_ORDERS_LIST_ERROR'

export const PROCESS_ORDERS_LIST_NV_REQUESTING = 'PROCESS_ORDERS_LIST_NV_REQUESTING'
export const PROCESS_ORDERS_LIST_NV_SUCCESS = 'PROCESS_ORDERS_LIST_NV_SUCCESS'
export const PROCESS_ORDERS_LIST_NV_ERROR = 'PROCESS_ORDERS_LIST_NV_ERROR'

export const PROCESS_ORDERS_KHACHHANG_REQUESTING = 'PROCESS_ORDERS_KHACHHANG_REQUESTING'
export const PROCESS_ORDERS_KHACHHANG_SUCCESS = 'PROCESS_ORDERS_KHACHHANG_SUCCESS'
export const PROCESS_ORDERS_KHACHHANG_ERROR = 'PROCESS_ORDERS_KHACHHANG_ERROR'

export const PROCESS_ORDERS_DAILY_REQUESTING = 'PROCESS_ORDERS_DAILY_REQUESTING'
export const PROCESS_ORDERS_DAILY_SUCCESS = 'PROCESS_ORDERS_DAILY_SUCCESS'
export const PROCESS_ORDERS_DAILY_ERROR = 'PROCESS_ORDERS_DAILY_ERROR'

export const PROCESS_ORDERS_APPROVE_LIST_REQUESTING = 'PROCESS_ORDERS_APPROVE_LIST_REQUESTING'
export const PROCESS_ORDERS_APPROVE_SET_LIST = 'PROCESS_ORDERS_APPROVE_SET_LIST'
export const PROCESS_ORDERS_SET_APPROVE_MESSAGE = 'PROCESS_ORDERS_SET_APPROVE_MESSAGE'
export const PROCESS_ORDERS_SET_APPROVE_ERROR = 'PROCESS_ORDERS_SET_APPROVE_ERROR'

export const PROCESS_ORDERS_EXPORT_XLS_INITING = 'PROCESS_ORDERS_EXPORT_XLS_INITING'
export const PROCESS_ORDERS_EXPORT_XLS_REQUESTING = 'PROCESS_ORDERS_EXPORT_XLS_REQUESTING'
export const PROCESS_ORDERS_EXPORT_XLS_SUCCESS = 'PROCESS_ORDERS_EXPORT_XLS_SUCCESS'
export const PROCESS_ORDERS_EXPORT_XLS_ERROR = 'PROCESS_ORDERS_EXPORT_XLS_ERROR'

export const PROCESS_ORDERS_SET_IS_LOADING = 'PROCESS_ORDERS_SET_IS_LOADING'
export const PROCESS_ORDERS_SET_TYPEOF_ORDER = 'PROCESS_ORDERS_SET_TYPEOF_ORDER'
export const PROCESS_ORDERS_SET_ORDER_ID = 'PROCESS_ORDERS_SET_ORDER_ID'
export const PROCESS_ORDERS_SET_MODE_FORM = 'PROCESS_ORDERS_SET_MODE_FORM'
export const PROCESS_ORDERS_SET_ORDER_INFOR = 'PROCESS_ORDERS_SET_ORDER_INFOR'
export const PROCESS_ORDERS_LOAD_ORDER_DETAILS = 'PROCESS_ORDERS_LOAD_ORDER_DETAILS'
export const PROCESS_ORDERS_DELETE_ORDER = 'PROCESS_ORDERS_DELETE_ORDER'
export const PROCESS_ORDERS_CREATE_ORDER_REQUESTING = 'PROCESS_ORDERS_CREATE_ORDER_REQUESTING'
export const PROCESS_ORDERS_SET_CALLBACK_FUNC = 'PROCESS_ORDERS_SET_CALLBACK_FUNC'
export const PROCESS_ORDERS_LOAD_ORDER_EXPORT = 'PROCESS_ORDERS_LOAD_ORDER_EXPORT'
export const PROCESS_ORDERS_CHECKED_LIST_REQUESTING = 'PROCESS_ORDERS_CHECKED_LIST_REQUESTING'
export const PROCESS_ORDERS_CONFIRM_REQUESTING = 'PROCESS_ORDERS_CONFIRM_REQUESTING'
export const PROCESS_ORDERS_LOAD_ORDER_EXCEL = 'PROCESS_ORDERS_LOAD_ORDER_EXCEL'

export const PROCESS_ORDERS_DELETE_ORDER_API = '/api/v1/export/deleteXuatKho'
export const PROCESS_ORDERS_LIST_API = '/api/v1/export/danhSachDonHangXuatKho'
export const PROCESS_ORDERS_EXPORT_API = '/api/v1/export/orders_export_by_store'
export const PROCESS_ORDERS_LIST_NV_API = '/api/v1/users/get_list_by_quanly'
export const PROCESS_ORDERS_CONFIRM_API = '/api/v1/export/update_XuatKho_qr_code'
export const PROCESS_ORDERS_CREATE_ORDER_API = '/api/v1/export/create_xuat_kho'
export const PROCESS_ORDERS_LOAD_ORDER_EXPORT_API = '/api/v1/export/in_xuat_kho'
export const PROCESS_ORDERS_LOAD_ORDER_DETAILS_API = '/api/v1/export/getDetailsXuatKho'
export const PROCESS_ORDERS_CHECKED_LIST_API = '/api/v1/export/find_lsXuatKho'
export const PROCESS_ORDERS_LOAD_ORDER_XLS_API = '/api/v1/export/export_excel_xuat_kho'

export const TYPEOF_ORDER = {
    FOR_DEFAULT: 1,
    FOR_STORE: 2
}
export const MODE = {
    IN_CREATE: 'IN_CREATE',
    IN_EDIT: 'IN_EDIT',
    IN_VIEW: 'IN_VIEW'
}


// WEBPACK FOOTER //
// ./src/views/ProcessOrders/constants.js